import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { useNewsletterSubscription } from '@/b2c/checkout/useNewsletterSubscription';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutNewsletterSubscription',
  setup(__props) {

const labels = useBlockLabels();
const { subscribe } = useNewsletterSubscription();


return (_ctx: any,_cache: any) => {
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_InputCheckbox, {
      modelValue: _unref(subscribe),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(subscribe) ? (subscribe).value = $event : null)),
      name: "subscribeToNewsletter",
      "show-errors": false,
      label: _unref(labels).baseAddressSubscribeToNewsletter
    }, null, 8, ["modelValue", "label"]),
    (_unref(labels).newsletterSignUpText)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "o-rte-caption pl-30",
          innerHTML: _unref(labels).newsletterSignUpText
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}
}

})